import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ListItem, ListItemText, Typography } from '@material-ui/core';
import { withStyles, WithStyles } from '@material-ui/core/styles';

import { SocialAccountIcon } from 'components';
import { useCurrentUser } from 'hooks';
import { connectionPopup } from 'helpers';

import styles from './itemStyles';

const ReachLinkedIn: FC<WithStyles<typeof styles>> = ({ classes }) => {
  const { t } = useTranslation();
  const currentUser = useCurrentUser();

  function handleConnect() {
    connectionPopup(currentUser.id, 'linkedin');
  }

  return (
    <ListItem disableGutters onClick={handleConnect} style={{ cursor: 'pointer' }}>
      <SocialAccountIcon active provider="linkedin" />
      <ListItemText disableTypography>
        <Typography variant="body2">{t('user:connectToLinkedIn')}</Typography>
      </ListItemText>
    </ListItem>
  );
};

export default withStyles(styles)(ReachLinkedIn);
